import { MarketingHeader, MarketingFooter } from "@/components/marketing";
import { PlanComparison } from "@/components/PlanComparison";

export default function PlanPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <MarketingHeader />
      <main className="max-w-6xl mx-auto px-6 py-20 sm:py-28">
        <PlanComparison
          mode="public"
          title="Alle planer og funktioner"
          subtitle="Sammenlign pakkerne og vælg den, der passer bedst til jer. Start med 30 dages gratis prøve. Priser i DKK inkl. moms."
        />
      </main>
      <MarketingFooter />
    </div>
  );
}
